import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import Divider from "@mui/material/Divider";
import { Card, Grid, Box, Typography } from "@mui/material";
// import { Link } from "react-router-dom";
// import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import CheckListQuestions from "./CheckListQuestions";
// import CheckListDetailTab from "./CheckListDetailTab";
import { useNavigate } from "react-router-dom";
// import { TabPanel, Tab, TabsList } from "../../../components/tabs/TabUnstyled";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";

export default function CheckListDetails() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);

  const [details, setDetails] = useState({});
  const [checklistSubSectionId, setChecklistSubSectionId] = useState(
    +params.get("c")
  );

  const tab = params.get("tab");
  const templateId = params.get("t");
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (checklistSubSectionId > 0) GetChecklistDetail();
  }, [checklistSubSectionId]);

  const GetChecklistDetail = async () => {
    const response = await axios.get(
      BaseURL.templateTool.GetChecklistSubSectionDetail +
        "checklistSubSectionId=" +
        checklistSubSectionId
    );

    if (response.data?.data) {
      setDetails(response.data?.data);
    }
  };

  return (
    <>
      <div
        className="row bg"
        style={{
          minwidth: "100%",
          backgroundColor: "#F9FAFB",
          marginLeft: "auto",
        }}
      >
        <div className="col-sm-12 col-lg-2 md-4 xl-2 block ">
          <Typography
            style={{
              textTransform: "capitalize",
              textDecoration: "none",
              color: "rgb(97, 169, 251)",
              cursor: "pointer",
            }}
            onClick={handleGoBack}
          >
            {"<-- Back to Checklists"}
          </Typography>
        </div>
        <div className="col-sm-12 col-lg-9 md-6 xl-9">
          <Box sx={{ width: "100%" }}>
            <Divider className="mt-3" />
            <div className="row">
              <CheckListQuestions
                checklistSubSectionId={checklistSubSectionId}
                details={details}
                templateId={templateId}
              />
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}
